<template>
    <div>
        <base-header type="gradient-success" class="pb-6">

        </base-header>
        <show-order/>

        <detail-order/>


    </div>
</template>

<script>
    import ShowOrder from "../../components/Order/ShowOrder";
    import {order_service} from '../../services/order/OrderService'
    import DetailOrder from "../../components/Order/DetailOrder";

    export default {
        name: "index",
        components: {DetailOrder, ShowOrder},
        created() {
            order_service.GetAllOrder()
            //order_service.GetAllProductSku()
            order_service.GetAllProduct()
            order_service.GetAllRestaurant()
            order_service.GetAllUsers()
            order_service.GetAllOrderStatus()
        }
    }
</script>

<style scoped>

</style>